document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll("[data-ai-video-id]");

  if (!sections.length) return;

  sections.forEach((section) => {
    const video = section.querySelector("video");
    const playButton = section.querySelector("[class*='ai-video-features-playbtn']");

    if (!video) return;

    const shouldAutoplay = video.dataset.autoplay === "true";

    // Intersection Observer for scroll-triggered autoplay
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (shouldAutoplay && video.paused) {
              const playPromise = video.play();
              if (playPromise !== undefined) {
                playPromise.catch(() => {
                  // Autoplay blocked — show play button
                  if (playButton) playButton.classList.remove("hidden");
                });
              }
            }
          } else {
            if (!video.paused) video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(section);

    // Manual play button
    if (playButton) {
      playButton.addEventListener("click", () => {
        video.play();
        playButton.classList.add("hidden");
      });
    }

    // Hide play button once video starts
    video.addEventListener("play", () => {
      if (playButton) playButton.classList.add("hidden");
    });

    // Show play button again if user pauses manually
    video.addEventListener("pause", () => {
      if (playButton && !shouldAutoplay) {
        playButton.classList.remove("hidden");
      }
    });
  });
});
